import { FC, useCallback, useMemo } from 'react';
import RawCalendar from 'react-calendar';
import { CalendarProps } from './Calendar.types';
import { LooseValue, Value } from 'react-calendar/dist/cjs/shared/types';
import { cutDateTime, isDateRange } from 'utils/date';

export const Calendar: FC<CalendarProps> = ({
    value: rawValue,
    onChange,
    selectRange,
    ...props
}) => {
    const handleChange = useCallback(
        (value: Value) => {
            if (selectRange) {
                onChange(
                    value && Array.isArray(value)
                        ? {
                              start: value[0] ? value[0].toISOString() : null,
                              end: value[1] ? value[1].toISOString() : null
                          }
                        : null
                );
            } else {
                onChange(cutDateTime(value as Maybe<Date>));
            }
        },
        [onChange, selectRange]
    );

    const value = useMemo<LooseValue>(() => {
        if (selectRange) {
            if (isDateRange(rawValue)) {
                return [rawValue.start ?? null, rawValue.end ?? null];
            }

            return null;
        }

        return rawValue ?? null;
    }, [rawValue, selectRange]);

    return (
        <RawCalendar
            formatMonthYear={(locale, date) =>
                date.toLocaleString(locale, { month: 'long' }) +
                ' ' +
                date.getFullYear()
            }
            value={value}
            onChange={handleChange}
            selectRange={selectRange}
            {...props}
        />
    );
};
